export default (items: Array<any>, key = 'alpha'): Array<any> => {
  const alpha = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
  return items.map((a, i) => {
    a[key] = alpha[i]
    return a
  })
}
